import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_3 = {
  key: 1,
  class: "error-text"
}
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "product-layout" }
const _hoisted_6 = {
  key: 0,
  class: "product-gallery"
}
const _hoisted_7 = { class: "product-content" }
const _hoisted_8 = { class: "product-title" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ImageCarousel = _resolveComponent("ImageCarousel")!
  const _component_FullscreenViewer = _resolveComponent("FullscreenViewer")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Загрузка..."))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
            : (_ctx.product)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Главная", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, " → ", -1)),
                    _createVNode(_component_router_link, { to: "/products" }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Продукция", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[4] || (_cache[4] = _createElementVNode("span", null, " → ", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.product.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.product.photo_urls && _ctx.product.photo_urls.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_ImageCarousel, {
                            images: _ctx.product.photo_urls,
                            alt: _ctx.product.name,
                            height: "400px",
                            onClick: _ctx.openFullscreen
                          }, null, 8, ["images", "alt", "onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.product.name), 1),
                      (_ctx.product.description)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "product-description",
                            innerHTML: _ctx.product.description
                          }, null, 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
      ]),
      _createVNode(_component_FullscreenViewer, {
        visible: _ctx.fullscreenVisible,
        images: _ctx.product?.photo_urls || [],
        alt: _ctx.product?.name || '',
        "start-index": _ctx.fullscreenIndex,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fullscreenVisible = false))
      }, null, 8, ["visible", "images", "alt", "start-index"])
    ]),
    _: 1
  }))
}